<template>
    <div class=" col-5 form-group col-customer_message"
        style="display: flex;flex-direction: column;justify-content: flex-start;margin-bottom: 0;">
        <div style="display: flex;flex-direction: row;justify-content: space-between; align-items: center;">
            <label for="customer_message">Customer Message <small>(Optional)</small></label>
        </div>
        <div class="menu-customer">
            <ul class="nav nav-tabs">
                <li v-for="(i, index) in listNav" :class="['nav-item', i.key==navIsCheck ? 'show' : '']" :key="i.id">
                    <a :class="['nav-link', i.key==navIsCheck ? 'active' : '']" href="#" @click.prevent="changeNav(i)">
                        <i :class="i.icon"></i> {{i.name}}
                    </a>
                    <input type="checkbox" :id="'nav-checkbox-'+i.key" v-model="i.checked" @click="ShowOptions(i, index)"/>
                </li>
                <li class="nav-item dropdown disabled">
                    <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" @click.prevent="() => { return false }">
                        <i class="fas fa-ellipsis-h"></i>
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="#">Action</a></li>
                        <li><a class="dropdown-item" href="#">Another action</a></li>
                        <li><a class="dropdown-item" href="#">Something else here</a></li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li><a class="dropdown-item" href="#">Separated link</a></li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="content-tab-customer">
            <div v-if="navIsCheck=='textBox'" :class="'content-'+navIsCheck">
                <!--
                <textarea id="customer_message"
                    :class="['form-control customer_message', (disabledState) ? 'disabled' : '']"
                    :disabled="disabledState" v-model="customer_message"
                    @change="setUpdate"
                    placeholder="We hope to continue doing business with you." maxlength="300"></textarea>
                <span class="maxSize">
                    {{ (customer_message != null) ? customer_message.length : 0 }}/300
                </span>
                -->
                <editor-customer-message :value="customer_message" :limit="numberWords" :limitType="'words'"
                    :placeholder="'We hope to continue doing business with you.'" :readonly="disabledState"
                    :editorClass="'form-control customer_message '" @input="setUpdate"
                    :emitOnLimitReached="true"></editor-customer-message>
            </div>
            <div v-if="navIsCheck=='payment'" :class="'content-'+navIsCheck">
                <paymentAgreement
                    :propData="propData"
                    :formTotal="normalizedFormTotal"
                    :optionsPayments="getPayments"
                    :checkState="paymentChecked"
                    @update:paymentAgreement="setPayment($event)"
                />
            </div>
        </div>
    </div>
</template>
<script>
import RichTextEditor from './../../RichTextEditor.vue'
import paymentAgreement from './paymentAgreement.vue'
export default {
    props: [
        "controlLoad",
        "propForm",
        "propTotal",
        "propdisabledSteps",
        "propNavCustomer",
        "propPayment",
    ],
    components: {
        "editor-customer-message": RichTextEditor,
        paymentAgreement
    },
    data() {
        return {
            customer_message: this.propForm?.customer_message || null,
            disabledState: this.propdisabledSteps?.customer || false,
            numberWords: 50,
            checkTextBox: true,
            checkPayment: false,
            navIsCheck: 'textBox',
            listNav2: [
                {key:'textBox'},
                {key:'payment'},
            ],
            listNav: [
                { id: 1, key:'textBox', name: 'Text Box', icon: 'fas fa-comment', disabled: false, checked: true },
                { id: 2, key:'payment', name: 'Payment Agreement', icon: 'fas fa-dollar-sign', disabled: false, checked: this.propNavCustomer?.payment || false },
                // { id: 3, name: 'Other Documents?', icon: 'fas fa-file-pdf', disabled: true, checked: false },
            ],
            propData: this.propForm,
            getPayments: this.propPayment,
            paymentChecked: false,
        };
    },
    mounted() {
        this.getKeyValSetting('customer_message_numberWords', 50).then((resul) => {
            this.numberWords = parseInt(resul);
        });
        if(this.propNavCustomer){
            this.listNav[0].checked = this.propNavCustomer?.textBox || true;
            this.listNav[1].checked = this.propNavCustomer?.payment || false;
        }
        // console.log('mounted propNavCustomer', this.listNav)
    },
    methods: {
        ShowOptions(i, index){
            this.navIsCheck = i.key;
            this.listNav[index].checked = !this.listNav[index].checked;
            // console.log('ShowOptions', this.listNav[index].checked);
            this.$emit('updateNavCustomer', {
                textBox: this.listNav[0].checked,
                payment: this.listNav[1].checked,
            });
            this.paymentChecked = this.listNav[1].checked;
        },
        changeNav(i){
            this.navIsCheck = i.key;
        },
        setUpdate(data) {
            // console.log('event change setUpdate customer_message', data)
            data = (data == null || data == undefined) ? this.customer_message : data;
            data = (typeof data == 'string') ? data : "";
            this.$emit('updateProps', data);
        },
        getKeyValSetting (meta_key, valueDefault) {
            return new Promise((resolve, reject) => {
                try{
                    window.apiv2
                    .post('getKeyValSetting', {
                        user_id: window.master_client,
                        org_id: window.localorgdata,
                        meta_key: meta_key,
                    })
                    .then((response) => {
                        // console.log(meta_key, response.data);
                        resolve(response.data.status ? response?.data?.r?.meta_value : valueDefault);
                    });
                }catch(e){
                    resolve(valueDefault);
                    reject(valueDefault);
                }
            });
        },
        setPayment(payload){
            this.$emit('updatePropsPayment', payload);
        }
    },
    watch: {
        propNavCustomer: function() {
            // console.log('watch propNavCustomer', this.propNavCustomer)
            this.listNav[0].checked = this.propNavCustomer?.textBox || true;
            this.listNav[1].checked = this.propNavCustomer?.payment || false;
        },
        propPayment: function() {
            this.getPayments = this.propPayment;
        },
    },
    computed: {
        normalizedFormTotal() {
            const total = parseFloat(this.propTotal);
            return Number.isNaN(total) ? 0 : total;
        },
    }
};
</script>
<style lang="scss">
.form-control.customer_message,
.quillWrapper.form-control.customer_message {}

.quillWrapper.form-control.customer_message .ql-editor li:not(.ql-direction-rtl)::before {
    left: -5px !important;
}
.menu-customer {
    position: relative;
    display: block;
    padding: 5px 15px;
    .nav-tabs .nav-link {
        border-top: 0px solid #dee2e6;
        border-left: 0px solid #dee2e6;
        border-right: 1px solid #dee2e6;
        color: #4F5467;
        padding: 0.5rem 0.5rem 0.5rem 0.5rem;
        &.dropdown-toggle{
            padding: 0.5rem 0.5rem;
        }
    }
    .nav-tabs .nav-item {
        border: 1px solid #dee2e6;
        &.show {
            border-bottom: 1px solid #fff;
        }
        .nav-link.active {
            color: #2962FF;
            background-color: #fff;
        }
    }
    .nav-tabs .nav-item {
        display: flex;
        gap: 5px;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .nav-tabs .nav-item input[type=checkbox] {
        margin-right: 4px;
        margin-left: 0px;
        width: 18px;
        height: 18px;
        cursor: pointer;
        border: 1px solid #dee2e6;
        border-bottom: 0px;
    }
}
.content-tab-customer {
    position: relative;
    height: 250px;
    overflow: hidden;
    .content-textBox {
        position: relative;
    }

}
</style>
